import { payload } from "../../../../../node_modules/@sveltejs/kit/src/runtime/client/payload.js";
const env = payload.env;

export const PUBLIC_LANG = env.PUBLIC_LANG;
export const PUBLIC_TIME_ZONE = env.PUBLIC_TIME_ZONE;
export const PUBLIC_TIME_LOCALE = env.PUBLIC_TIME_LOCALE;
export const PUBLIC_TIME_HOUR_FORMAT = env.PUBLIC_TIME_HOUR_FORMAT;
export const PUBLIC_TIME_START_OF_WEEK = env.PUBLIC_TIME_START_OF_WEEK;
export const PUBLIC_TECHNICAL_SUPPORT_EMAIL = env.PUBLIC_TECHNICAL_SUPPORT_EMAIL;
export const PUBLIC_MAX_IMAGE_DIMENSION = env.PUBLIC_MAX_IMAGE_DIMENSION;
export const PUBLIC_IMAGE_QUALITY = env.PUBLIC_IMAGE_QUALITY;
export const PUBLIC_MAX_IMAGE_FILE_SIZE = env.PUBLIC_MAX_IMAGE_FILE_SIZE;
export const PUBLIC_MAX_VIDEO_FILE_SIZE = env.PUBLIC_MAX_VIDEO_FILE_SIZE;
export const PUBLIC_MAX_VIDEO_DIMENSION = env.PUBLIC_MAX_VIDEO_DIMENSION;
export const PUBLIC_ALLOW_MEMBER_POSTERS = env.PUBLIC_ALLOW_MEMBER_POSTERS;
export const PUBLIC_MAX_VIDEO_DURATION = env.PUBLIC_MAX_VIDEO_DURATION;
export const PUBLIC_SHOW_BLOCK_GRID_LINES = env.PUBLIC_SHOW_BLOCK_GRID_LINES;
export const PUBLIC_SHOW_DEBUG_STYLES = env.PUBLIC_SHOW_DEBUG_STYLES;
export const PUBLIC_IMAGE_AVIF_EFFORT = env.PUBLIC_IMAGE_AVIF_EFFORT;
export const PUBLIC_GRAPHIC_ENTROPY_THRESHOLD = env.PUBLIC_GRAPHIC_ENTROPY_THRESHOLD;
